import * as _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import actions from "@/actions";

import Panel from "../base/Panel";
import PanelButtons from "./panel-buttons";

const HighLightPanel = ({ changeMapMode, setHighlight }) => (
    <Panel title="Highlight Direction">
        {_.map(PanelButtons, (Button, name) => (
            <Button
                key={`highlight-direction-${name}`}
                color="#FFF"
                title={name}
                className="tools-bar-button"
                onClick={() => {
                    if (name !== "Clear") {
                        changeMapMode("highlight", { direction: name });
                    } else {
                        setHighlight({ column: null, row: null });
                    }
                }}
            />
        ))}
    </Panel>
);

HighLightPanel.propTypes = {
    changeMapMode: PropTypes.func.isRequired,
    setHighlight: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    setHighlight: actions.map.general.setHighlight,
    changeMapMode: actions.map.general.changeMode,
};
export default connect(mapStateToProps, mapDispatchToProps)(HighLightPanel);
